// extracted by mini-css-extract-plugin
export default {"title":"AdvancePaymentDetails_title__6HNnF","total":"AdvancePaymentDetails_total__KrJXF","edit":"AdvancePaymentDetails_edit__WWTT0"};